/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SendMessageTask
 */
export interface SendMessageTask {
    /**
     *
     * @type {string}
     * @memberof SendMessageTask
     */
    action?: string;
    /**
     *
     * @type {string}
     * @memberof SendMessageTask
     */
    payload?: string;
}

/**
 * Check if a given object implements the SendMessageTask interface.
 */
export function instanceOfSendMessageTask(
    value: object,
): value is SendMessageTask {
    return true;
}

export function SendMessageTaskFromJSON(json: any): SendMessageTask {
    return SendMessageTaskFromJSONTyped(json, false);
}

export function SendMessageTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SendMessageTask {
    if (json == null) {
        return json;
    }
    return {
        action: json["action"] == null ? undefined : json["action"],
        payload: json["payload"] == null ? undefined : json["payload"],
    };
}

export function SendMessageTaskToJSON(value?: SendMessageTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        action: value["action"],
        payload: value["payload"],
    };
}
